export const ChildOrganizationRelationshipType = {
    isBranchOf: 'isBranchOf',
    isDuplicateOf: 'isDuplicateOf',
    isPartOfHoed: 'isPartOfHoed',
} as const;

export type ChildOrganizationRelationshipType =
    (typeof ChildOrganizationRelationshipType)[keyof typeof ChildOrganizationRelationshipType];

export const ParentOrganizationRelationshipType = {
    isDuplicatedBy: 'isDuplicatedBy',
    isHoedOf: 'isHoedOf',
    isParentOf: 'isParentOf',
} as const;

export type ParentOrganizationRelationshipType =
    (typeof ParentOrganizationRelationshipType)[keyof typeof ParentOrganizationRelationshipType];

export const OppositeChildOrganizationRelationshipType = {
    [ChildOrganizationRelationshipType.isBranchOf]: ParentOrganizationRelationshipType.isParentOf,
    [ChildOrganizationRelationshipType.isDuplicateOf]: ParentOrganizationRelationshipType.isDuplicatedBy,
    [ChildOrganizationRelationshipType.isPartOfHoed]: ParentOrganizationRelationshipType.isHoedOf,
} as const;

export const OppositeParentOrganizationRelationshipType = {
    [ParentOrganizationRelationshipType.isDuplicatedBy]: ChildOrganizationRelationshipType.isDuplicateOf,
    [ParentOrganizationRelationshipType.isParentOf]: ChildOrganizationRelationshipType.isBranchOf,
    [ParentOrganizationRelationshipType.isHoedOf]: ChildOrganizationRelationshipType.isPartOfHoed,
} as const;

export const OrganizationRelationshipType = {
    ...ChildOrganizationRelationshipType,
    ...ParentOrganizationRelationshipType,
} as const;

export type OrganizationRelationshipType =
    (typeof OrganizationRelationshipType)[keyof typeof OrganizationRelationshipType];

export function isParentOrganizationRelationshipType(
    type: OrganizationRelationshipType
): type is ParentOrganizationRelationshipType {
    return Object.values(ParentOrganizationRelationshipType).includes(type as ParentOrganizationRelationshipType);
}

export function isChildOrganizationRelationshipType(
    type: OrganizationRelationshipType
): type is ChildOrganizationRelationshipType {
    return Object.values(ChildOrganizationRelationshipType).includes(type as ChildOrganizationRelationshipType);
}
